import { Component } from '@angular/core';

@Component({
  selector: 'pcs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
